import React, { useEffect, useState } from 'react';
import './Certifications.css';
import { FaUniversity } from 'react-icons/fa';
import { SiDatabricks, SiGoogle } from 'react-icons/si';
import { Certification } from '../types';
import { getCertifications } from '../queries/getCertifications';

// Import certificate images
import databricksCert from '../images/databricks_cert.png';
import huggingfaceCert from '../images/huggingface_cert.png';
import llamaIndexCert from '../images/llamaindex_cert.png';
import googleDevCert from '../images/google_dev_cert.png';

const iconData: { [key: string]: JSX.Element } = {
  'databricks': <SiDatabricks />,
  'huggingface': <FaUniversity />,
  'llamaindex': <FaUniversity />,
  'google': <SiGoogle />
}

// Updated certifications data with your new certificates
const FALLBACK_CERTIFICATIONS_DATA: Certification[] = [
  {
    title: "Databricks Accredited Generative AI Fundamentals",
    issuer: "Databricks Academy",
    issuedDate: "December 2, 2025",
    link: "#",
    iconName: "databricks"
  },
  {
    title: "Hugging Face LLM Developer - Fundamentals of LLMs",
    issuer: "Hugging Face",
    issuedDate: "December 2, 2025",
    link: "#",
    iconName: "huggingface"
  },
  {
    title: "Gen AI 360° - RAG with LangChain & LlamaIndex",
    issuer: "Activeloop, TowardsAI & Intel Disruptor Initiative",
    issuedDate: "December 2, 2025",
    link: "#",
    iconName: "llamaindex"
  },
  {
    title: "Google Developer Groups - Gen AI Study Jam 2024",
    issuer: "Google Developer Groups on Campus",
    issuedDate: "October 1 - November 1, 2024",
    link: "#",
    iconName: "google"
  }
];

const Certifications: React.FC = () => {
  const [certifications, setCertifications] = useState<Certification[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchCertifications() {
      try {
        const data = await getCertifications();
        setCertifications(data);
      } catch (err) {
        console.error("Failed to fetch certifications data:", err);
        setError("Failed to load certifications data. Showing sample content.");
        // Use fallback data when API request fails
        setCertifications(FALLBACK_CERTIFICATIONS_DATA);
      } finally {
        setLoading(false);
      }
    }

    fetchCertifications();
  }, []);

  if (loading) return <div className="certifications-loading">Loading certifications...</div>;

  if (error) {
    console.warn(error);
  }

  // If we still don't have data for some reason, use fallback
  const displayCertifications = certifications.length > 0 ? certifications : FALLBACK_CERTIFICATIONS_DATA;

  // Certificate images array
  const certImages = [databricksCert, huggingfaceCert, llamaIndexCert, googleDevCert];

  return (
    <div className="certifications-container">
      <h2 className="certifications-title">🎓 Vinayak Singh's Certifications</h2>
      <p className="certifications-subtitle">AI & Full Stack Innovator | Building Products that Think, Learn & Scale</p>
      <div className="certifications-grid">
        {displayCertifications.map((cert, index) => (
          <div key={index} className="certification-card" style={{ '--delay': `${index * 0.2}s` } as React.CSSProperties}>
            <div className="certification-image-container">
              <img src={certImages[index]} alt={cert.title} className="certification-image" />
            </div>
            <div className="certification-content">
              <div className="certification-icon">{iconData[cert.iconName] || <FaUniversity />}</div>
              <h3>{cert.title}</h3>
              <p className="issuer">{cert.issuer}</p>
              {cert.issuedDate && <span className="issued-date">Issued: {cert.issuedDate}</span>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Certifications;